import React from 'react'
import "../css/jp_Breadcrumb.css"
import { useNavigate } from 'react-router-dom'
import { BurgerIconic } from '../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter'
import { useMediaQuery } from '../../../../context-module/context-configuration/auth-provider/mediaProvider/mediaProvider'

type Props = {
  onToggleSidebar?: () => void
}

const JPPositionBread = ({ onToggleSidebar }: Props) => {
    const navigate = useNavigate()
    const isMobile = useMediaQuery('(max-width: 500px)');
    const onClickCareer = () => {
        navigate("/career")
    }

    return (
        <div className='scl--jp-position-career-breadcrumb'>
            <div className='scl--jpcb-con-st'>
                {isMobile && 
                    <button onClick={onToggleSidebar}>
                        <BurgerIconic/>
                    </button>
                }
                
                <h3 onClick={onClickCareer} //NOSONAR
                >Career</h3> 
                <span>/</span>
                <h4>All Position</h4>
            </div>
        </div>
    )
}

export default JPPositionBread